import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { compose } from '@beef/utils';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { withRenderFlag } from '@beef/react';
import { selectRouterAvailable, shouldShowAddressNotAvailableBlock } from "../../../../../store/selectors";
import { SubscriptionCard } from "../SubscriptionCard";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _AddressNotAvailableBlock = function _AddressNotAvailableBlock(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement(SubscriptionCard, _extends({}, data, {
    className: cx('notAvailableBlock'),
    "data-t-id": "components-AddressNotAvailableBlock"
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    data: selectRouterAvailable(state),
    shouldRender: shouldShowAddressNotAvailableBlock(state)
  };
};
var connector = connect(mapStateToProps);
export var AddressNotAvailableBlock = compose(connector, withRenderFlag)(_AddressNotAvailableBlock);